import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    right: '0%',
    left: '10px',
    bottom: '5px',
    backgroundColor: '#EBECF4',
  },
  menu: {
    display: 'flex',
    flexDirection: 'row',
    margin: '15px 0px 5px 0px',
    objectFit: 'contain',
    alignItems: 'center',
    textAlign: 'center',
  },
  imgLine: {
    display: 'flex',
    position: 'relative',
    marginLeft: '30px',
    marginRight: '15px',
  },
  pagination: {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    paddingBottom: '45px',
  },
  table: {
    overflowY: 'auto',
  },
  activeFilter: {
    color: '#3560FF',
  },
  selectedRecordCountDisplay: {
    marginTop: '30px',
    marginLeft: '-15px',
  },
  roundSmallPink: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#EA2075',
    textAlign: 'center',
  },
  roundSmallBlue: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#3560FF',
    textAlign: 'center',
  },
  icon: {
    color: 'white',
    marginTop: '5px',
    width: '0.5em',
    height: '0.5em',
  },
  filterMenuCheckbox: {
    width: '14px',
    height: '14px',
    borderRadius: '2px',
    margin: '5px 13px 5px 7px',
    cursor: 'pointer',
    border: 'solid 1px rgba(44, 45, 62, 0.8)',
    '&': {
      color: 'none',
    },
    '&.Mui-checked': {
      color: '#3C419A',
      borderColor: '#100f12',
    },
  },
}));
